import React from 'react';

const FlexibilitySection = () => {
  return (
    <section className="py-20 px-6 ">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4"> Real-Time Resource Monitoring</h2>
            <p className="text-lg text-gray-600">  Keep track of CPU, memory, storage, and network usage across your infrastructure. Make informed decisions with live performance insights.
</p>
          </div>
          <div>
            <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm max-w-sm mx-auto">
              <div className="flex items-center gap-2 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-green-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                </svg>
                <span className="font-medium text-gray-900">  Resource Usage
</span>
              </div>
              <div className="grid grid-cols-7 gap-1 mb-4">
                <div className="text-center text-xs text-gray-600 py-1">M</div>
                <div className="text-center text-xs text-gray-600 py-1">T</div>
                <div className="text-center text-xs text-gray-600 py-1">W</div>
                <div className="text-center text-xs text-gray-600 py-1">T</div>
                <div className="text-center text-xs text-gray-600 py-1">F</div>
                <div className="text-center text-xs text-gray-600 py-1">S</div>
                <div className="text-center text-xs text-gray-600 py-1">S</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">1</div>
                <div className="text-center text-xs py-2 rounded bg-green-600 text-white">2</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">3</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">4</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">5</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">6</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">7</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">8</div>
                <div className="text-center text-xs py-2 rounded bg-green-600/40 text-green-600">9</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">10</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">11</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">12</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">13</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">14</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">15</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">16</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">17</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">18</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">19</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">20</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">21</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">22</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">23</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">24</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">25</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">26</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">27</div>
                <div className="text-center text-xs py-2 rounded text-gray-900">28</div>
              </div>
              <div className="text-center">
                <span className="text-xs text-gray-600">02:00 - 06:00 (Europe/Berlin)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexibilitySection;